import { Box, Button, Card, ClickAwayListener, DialogActions, DialogContent, DialogTitle, Paper, Stack, Typography } from "@mui/material";
import React, { useMemo } from "react"
import LockIcon from "../../assets/icons/lockIcon";
import { Group } from "../../reducer/user.reducer";
import { selectFeatureRestrictionDialog, selectUserSubscriptionPlansData } from "../../selectors/user";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ClearIcon from "../../assets/icons/ClearIcon";
import CheckIcon from "@mui/icons-material/Check";
interface FeatureRestrictionDialogProps {
    feature: string
    featureRestrictionCode?: string
    open: boolean;
    onClose: (() => void) | undefined;
    group?: Group
}

const FeatureRestrictionDialog: React.FC<FeatureRestrictionDialogProps> = ({ feature, open, onClose, group, featureRestrictionCode }) => {
    const navigate = useNavigate()
    const featureRestrictionDialogData = useSelector(selectFeatureRestrictionDialog);
    const userSubscriptionPlansData = useSelector(selectUserSubscriptionPlansData);
    const featureInfo = useMemo(() => {
        if (!userSubscriptionPlansData) return null;
        for (const [plan, features] of Object.entries(userSubscriptionPlansData)) {
            if (!Array.isArray(features)) continue;

            const found = features.find(
                (f: any) => f.featureCode === featureRestrictionCode
            );

            if (found) {
                console.log("FOUND in plan:", plan, found);
                return found;
            }
        }
        return null;
    }, [featureRestrictionCode, userSubscriptionPlansData]);

    return !open ? null : (
        // <ClickAwayListener onClickAway={() => onClose?.()}>
        //     <Card
        //         elevation={8}
        //         sx={{
        //             position: "absolute",
        //             top: "50%",
        //             left: "50%",
        //             transform: "translate(-50%, -50%)",
        //             zIndex: 99999,
        //             width: "100%",
        //             maxWidth: 616,
        //             borderRadius: "4px",
        //             overflow: "hidden",
        //         }}
        //     >
        //         {featureInfo?.mediaUrl ? (
        //             <Box
        //                 component="img"
        //                 src={encodeURI(featureInfo.mediaUrl.trim())}
        //                 alt={featureInfo?.name ?? "feature image"}
        //                 sx={{
        //                     width: "100%",
        //                     height: 220,
        //                     objectFit: "cover",
        //                     p: 2
        //                 }}
        //             />
        //         ) : (
        //             <div className="flex justify-center items-center p-2 mt-2">
        //                 <LockIcon
        //                     className="w-10 h-10 text-yellow-500"
        //                     sx={{ height: "24px", width: "24px" }}
        //                 />
        //             </div>
        //         )}
        //         <Box p={3}>
        //             <Typography
        //                 fontSize="26px"
        //                 fontWeight={500}
        //                 textAlign="start"
        //                 mb={1}
        //             >
        //                 {featureInfo?.heading || featureInfo?.name || feature}
        //             </Typography>

        //             <Typography
        //                 fontSize="16px"
        //                 lineHeight="26px"
        //                 color="text.secondary"
        //                 textAlign="start"
        //                 mb={'12px'}
        //             >
        //                 {featureInfo?.description ||
        //                     `Your current plan does not include ${feature}. Upgrade to unlock advanced tools and trading features.`}
        //             </Typography>
        //             <Stack direction="row" spacing={2} mb={'12px'}><Paper
        //                 sx={{
        //                     flex: 1,
        //                     p: '9px',
        //                     borderRadius: "4px",
        //                     backgroundColor: "#fafafa",
        //                     height: "66px"
        //                 }}
        //             >
        //                 <Typography fontSize="12px" color="text.secondary">
        //                     Current Plan
        //                 </Typography>

        //                 <Box
        //                     display="flex"
        //                     alignItems="center"
        //                     justifyContent="space-between"
        //                     mt={1}
        //                 >
        //                     <Typography fontWeight={500}>Basic</Typography>
        //                     <ClearIcon fontSize="small" />
        //                 </Box>
        //             </Paper><Paper
        //                 sx={{
        //                     flex: 1,
        //                     p: '9px',
        //                     borderRadius: "4px",
        //                     border: "1px solid #e0e0e0",
        //                     height: "66px"
        //                 }}
        //             >
        //                     <Typography fontSize="12px" color="text.secondary">
        //                         After Sign-in
        //                     </Typography>

        //                     <Box
        //                         display="flex"
        //                         alignItems="center"
        //                         justifyContent="space-between"
        //                         mt={1}
        //                     >
        //                         <Typography fontWeight={500}>Premium</Typography>
        //                         <CheckIcon fontSize="small" color="success" />
        //                     </Box>
        //                 </Paper>
        //             </Stack>

        //             {/* CTA */}
        //             <Box
        //                 display="flex"
        //                 justifyContent="center"
        //                 mt={2}

        //             >
        //                 <Button
        //                     size="small"
        //                     variant="contained"
        //                     onClick={() => {
        //                         if (featureRestrictionDialogData.revertToHome) {
        //                             navigate("/");
        //                         } else {
        //                             onClose?.();
        //                         }
        //                     }}
        //                 >
        //                     {featureRestrictionDialogData.revertToHome
        //                         ? "Go to Homepage"
        //                         : "Start 30-day Free Trial"}
        //                 </Button>
        //             </Box>
        //         </Box>
        //     </Card>
        // </ClickAwayListener>
        (<ClickAwayListener onClickAway={() => { onClose ? onClose() : null }}>
            <Card elevation={6} sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translateX(-50%) translateY(-50%)',
                zIndex: 99999
            }}>
                <DialogTitle className="text-lg font-medium" sx={{ textAlign: 'center', pb: 1, fontSize: '28px' }}>
                    <div className="flex justify-center">
                        <LockIcon className="w-10 h-10 text-yellow-500" sx={{ height: '24px', width: '24px' }} />
                    </div>
                    {feature}
                </DialogTitle>
                <DialogContent className=" text-center font-medium" sx={{ pb: 0, maxWidth: '500px' }}>
                    <Typography sx={{ fontSize: '16px' }} >
                        Your plan does not include{' '}
                        <Typography component="span" fontWeight={500}>
                            {feature.toLowerCase()}
                        </Typography>. Upgrade to unlock advanced tools and trading features.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button variant='contained' onClick={() => {
                        if (featureRestrictionDialogData.revertToHome) {
                            navigate('/')
                            return
                        } else {
                            if (onClose) onClose();
                        }
                    }}>
                        {featureRestrictionDialogData.revertToHome ? 'Go to Homepage' : '30-day free trial'}

                    </Button>


                </DialogActions>
            </Card>
        </ClickAwayListener>));
}


export default FeatureRestrictionDialog;